import { render, staticRenderFns } from "./HotelRoomItem.vue?vue&type=template&id=c3d8f566&"
import script from "./HotelRoomItem.vue?vue&type=script&lang=js&"
export * from "./HotelRoomItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports